// extracted by css-extract-rspack-plugin
export default {"lazyChartIsModal":"lazyChartIsModal-Gd6HPo"};